function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M29.63,213.01v-.34c0-30.87,23.65-55.09,55.64-55.09,21.63,0,35.59,9.13,44.94,21.97l-22.08,17.13c-6.08-7.44-13.07-12.39-23.2-12.39-14.87,0-25.23,12.73-25.23,28.17v.34c0,15.89,10.47,28.28,25.23,28.28,11.04,0,17.57-5.18,23.88-12.84l22.08,15.77c-10.02,13.75-23.43,23.89-46.74,23.89-30.19-.11-54.51-23.21-54.51-54.87h0Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "137.68 159.98 166.63 159.98 166.63 198.98 204.5 198.98 204.5 159.98 233.46 159.98 233.46 264.71 204.5 264.71 204.5 224.6 166.63 224.6 166.63 264.71 137.68 264.71 137.68 159.98"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  className: "cls-1",
  points: "137.68 159.98 166.63 159.98 166.63 198.98 204.5 198.98 204.5 159.98 233.46 159.98 233.46 264.71 204.5 264.71 204.5 224.6 166.63 224.6 166.63 264.71 137.68 264.71 137.68 159.98"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M358.8,249.54l16.03-19.13c10.39,8.18,21.66,12.49,33.71,12.49,7.85,0,12.05-2.65,12.05-7.08v-.22c0-4.5-3.49-6.75-17.99-10.24-22.49-5.17-39.92-11.47-39.92-33.07v.24c0-19.94,15.72-34.3,41.46-34.3,18.23,0,32.47,4.9,44.08,14.24l-14.81,20.97c-9.8-7.06-20.5-10.6-29.96-10.6-7.18,0-10.71,2.96-10.71,6.84v.15c0,4.76,3.54,6.87,18.16,10.08,23.81,5.21,38.65,12.96,38.65,32.45v.58c0,21.23-16.8,33.83-42,33.83-18.46-.11-35.92-5.86-48.74-17.25h0Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M310.53,223.49h-23.5l11.81-29.64,11.7,29.64h0ZM240.69,264.71h30.24l7.51-18.94h40.78l7.51,18.94h30.91l-44.33-104.73h-28.51l-44.11,104.73h0Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-1",
  d: "M168.76,278.86c0-.56.32-.78.86-.78h22.48c14.45,0,22.85,7.39,22.85,20.05,0,11.99-7.17,20.05-22.51,20.05h-11.31v21.5c0,.56-.21.78-.86.78h-10.53c-.54,0-.86-.33-.86-.89l-.11-60.72ZM190.03,307.16c8.11,0,12.33-2.85,12.33-9.53s-4.11-9.53-12.22-9.53h-7.9v18.94h7.8v.11Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M220.1,295.68c0-.49.4-.89.89-.89h5.55c.44,0,.76.22.98.67l3.17,7.24c3.17-6.02,7.75-9.02,14.2-9.02.66,0,1.42.11,2.29.22.55.11.76.45.76,1v8.91c0,.67-.33.89-.98.67-.98-.22-1.97-.22-2.95-.22-9.94,0-12.78,6.68-12.78,18.38v17.04c0,.56-.22.79-.87.79h-9.52c-.54,0-.76-.23-.76-.9v-43.89Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M273,293.89c13.81,0,22.61,9.8,22.61,24.07s-8.58,23.95-22.61,23.95-22.72-9.69-22.72-23.95,8.8-24.07,22.72-24.07ZM272.77,332.77c7.02,0,10.92-6.02,10.92-14.82s-3.9-15.04-10.92-15.04-10.58,6.13-10.58,14.82,3.79,15.04,10.58,15.04Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M324.03,294.79c.55,0,.77.23.77.93v7.06c0,.58-.22.93-.88.93h-8.03v20.61c0,6.24,1.09,7.24,5.32,7.24.87,0,1.74-.11,2.61-.22.65-.11.98.22.98.78v7.51c0,.56-.23.79-.79.9-2.59.34-4.39.45-6.53.45-9.01,0-12.73-2.82-12.73-13.52v-23.76h-6.91c-.49,0-.89-.4-.89-.89v-7.13c0-.49.4-.89.89-.89h6.91v-6.8c0-.45.23-.78.7-1l9.38-4.35c.7-.22,1.06,0,1.06.67v11.48h8.14Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M340.38,320.42c.22,7.69,3.9,12.26,10.8,12.26,4.34,0,7.57-2.34,8.91-6.02.22-.45.56-.67,1-.67h9.36c.67,0,1,.33.78,1-2.67,9.58-10.02,14.37-20.38,14.37-13.59,0-22.05-9.69-22.05-24.07s8.91-23.95,21.83-23.95c13.81,0,20.61,10.14,21.16,23.95.11.67.22,1.45.22,2.23,0,.49-.4.89-.89.89h-30.74s0,0,0,0ZM360.43,313.73c-.78-6.91-4.23-10.47-9.91-10.47-6.35,0-9.58,4.79-10.14,10.47h20.05Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M418.36,323.65c.67,0,1.01.34.79,1.01-1.8,11.13-9.22,17.77-20.35,17.77-13.15,0-21.58-9.78-21.58-23.95s8.21-24.51,21.81-24.51c10.45,0,18.66,5.51,20.01,16.53.11.67-.22,1.01-.9,1.01h-9.44c-.56,0-.79-.22-1.01-.79-.9-4.83-3.93-7.53-8.54-7.53-7.31,0-10.34,6.97-10.34,15.29s3.15,14.73,10,14.73c4.83,0,8.09-3.26,9.1-8.66.22-.56.45-.79,1.01-.79h9.44v-.11Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M448.2,294.79c.56.32.78.54.23,1.21v6.8c.55.56-.34.9-.34.9h-8.57v20.61c0,6.24,1.09,7.24,5.32,7.24.87,0,1.74-.11,2.61-.22.65-.11.98.22.98.78v7.21c0,.53-.21.74-.74.85-2.45.32-4.15.43-6.17.43-8.51,0-12.02-2.66-12.02-12.77v-24.13h-6.91c-.49,0-.89-.4-.89-.89v-7.13c0-.49.4-.89.89-.89h6.91v-6.8c0-.45.23-.78.7-1l9.38-4.35c.7-.22,1.06,0,1.06.67v11.48h7.56Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M454.1,290.44c0-4.79,3.45-8.13,8.13-8.13s8.13,3.34,8.13,8.13-3.45,8.13-8.13,8.13-8.13-3.23-8.13-8.13ZM468.14,290.44c0-3.79-2.45-6.24-6.01-6.24s-6.01,2.45-6.01,6.24,2.34,6.24,6.01,6.24,6.01-2.45,6.01-6.24ZM459.57,286.54c-.45-.11-.34-.22-.23-.66h2.9c2.12.43,3.23,1.44,3.23,3,0,1-.33,1.78-1.23,2.23l1.23,2.67c.11.22-.33-.1-.33-.1h-1.45s-.11.54-.22.43l-1.11-2.66h-.55v2.55s-.79.22-.9-.32h-1.45c-.11.54-.22.43.12.32v-7.46ZM462.35,290.34c.78-.46,1.11-.79,1.11-1.35s-.33-.89-1.11-.88h-1.66v2.23h1.66Z"
}));

var SvgChasProtect = function SvgChasProtect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#395998"
    },
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "80 80 350 350",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasProtect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chas-protect.90e8253c.svg";
export { ForwardRef as ReactComponent };